import type { IconSvgObject } from './types';

const CircleGaugeIcon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 6.08296C12.6748 6.0284 12.3407 6 12 6C8.68629 6 6 8.68629 6 12C6 13.0929 6.29218 14.1175 6.80269 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.917 11C17.9716 11.3252 18 11.6593 18 12C18 13.0929 17.7078 14.1175 17.1973 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 12L16 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CircleGaugeIcon;
